import { FC } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { useAppDispatch, useAppSelector } from '@shared/store';

import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import { RadioGroup } from '@zvuk-b2b/ui-kit';

import { selectMediaType } from '../../slices/createAdCampaign/selectors';
import { resetCreateAdCampaign, setMediaType } from '../../slices/createAdCampaign/slice';
import styles from './index.module.scss';
import { TEXTS } from './texts';

const SelectAdTypeModal: FC<ModalProps[ModalTypes.SELECT_AD_CAMPAIGN_TYPE]> = ({ close, openModal }) => {
  const dispatch = useAppDispatch();
  const adMediaType = useAppSelector(selectMediaType) ?? AdCampaignMediaTypeEnum.Audio;

  const handleClose = () => {
    dispatch(resetCreateAdCampaign());
    close();
  };

  const handleTypeChange = (newType: AdCampaignMediaTypeEnum) => {
    if (adMediaType !== newType) {
      dispatch(resetCreateAdCampaign());
      dispatch(setMediaType(newType));
    }
  };

  const onSubmitClick = () => {
    Promise.resolve()
      .then(() => close())
      .then(() => {
        openModal(ModalTypes.AD_CAMPAIGN_STEPPER_CREATE, {
          adCampaignMediaType: adMediaType,
          canBackToAdCampaignTypeSelect: true,
        });
      });
  };

  return (
    <ModalScreen
      title={TEXTS.SELECT_AD_TYPE_TITLE}
      titlePlacement="left"
      onClose={handleClose}
      actionButtons={[
        <Button
          key="button_select_ad_modal_next"
          elementId="button_select_ad_modal_next"
          type={ButtonType.PRIMARY}
          onClick={onSubmitClick}>
          {TEXTS.NEXT}
        </Button>,
        <Button
          key="button_select_ad_modal_cancel"
          elementId="button_select_ad_modal_cancel"
          type={ButtonType.SECONDARY}
          onClick={handleClose}>
          {TEXTS.CANCEL}
        </Button>,
      ]}>
      <RadioGroup
        className={styles.wrapper}
        value={adMediaType}
        onValueChange={(value) => handleTypeChange(value as AdCampaignMediaTypeEnum)}>
        <RadioGroup.Item
          value={AdCampaignMediaTypeEnum.Audio}
          data-testid={`select_ad_type_${AdCampaignMediaTypeEnum.Audio}`}>
          {TEXTS.AUDIO_AD}
        </RadioGroup.Item>
        <RadioGroup.Item
          value={AdCampaignMediaTypeEnum.Video}
          data-testid={`select_ad_type_${AdCampaignMediaTypeEnum.Video}`}>
          {TEXTS.VIDEO_AD}
        </RadioGroup.Item>
      </RadioGroup>
    </ModalScreen>
  );
};

export default SelectAdTypeModal;
